import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-center text-sm text-gray-500 py-4">
      <p>
        © {new Date().getFullYear()} EventByCar. {t("footer.rights_reserved")} |{" "}
        <Link to="/privacy-policy" className="text-blue-500 hover:underline">
          {t("footer.privacy_policy")}
        </Link>
      </p>
    </footer>
  );
};

export default Footer;
